import {numberFilter} from "./numbers.js";


const BYTES_TO_UNIT_UNITS  = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

/**
 * Konwertuje rozmiar w bajtach na jednostkę
 * @param {Number} bytes Rozmiar w bajtach
 * @param {Number} precision
 * @returns {string}
 */
export const bytesToUnit = (bytes, precision = 1) => {
    bytes = Number(bytes) || 0;
    if (bytes === 0) {
        return '0 B';
    }
    let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return (bytes / Math.pow(1024, i)).toFixed(precision) + ' ' + BYTES_TO_UNIT_UNITS[i];
};


/**
 * Konwertuje rozmiar na bajty
 * @param {String} input Rozmiar
 * @returns {Number}
 */
export const unitToBytes = (input) => {
    input = String(input);
    const unit = input.substring(input.length - 2).replace(/[^A-z]/g, '');
    let digits = numberFilter(input);
    if (unit === '') {
        return digits;
    }
    let pow = 0;
    let foundUnit = false;
    for (let u of BYTES_TO_UNIT_UNITS) {
        if (unit === u || unit === u.substring(0, 1)) {
            foundUnit = true;
            break
        } else {
            pow++;
        }
    }
    if (!foundUnit) {
        throw `Invalid unit '${unit}'`;
    }
    return digits * Math.pow(1024, pow);
};


/**
 * Zaokrągla liczbę do wielokrotności
 * @param {number} numToRound
 * @param {number} multiple
 * @returns {number}
 */
export const roundUpToMultiple = (numToRound, multiple) => {
    if (multiple === 0) {
        return numToRound;
    }
    const remainder = numToRound % multiple;
    if (remainder === 0) {
        return numToRound;
    }
    return numToRound + multiple - remainder;
}


/**
 * Konwertuje stopnie na radiany
 * @param {number} deg
 * @returns {number}
 */
export const deg2rad = deg => (Math.PI / 180) * deg;

export function arraySum(array) {
    if (!Array.isArray(array)) {
        return 0;
    }
    return array.reduce((a, b) => a + b, 0);
}

export function arrayAverage(array) {
    if (!Array.isArray(array) || array.length === 0) {
        return 0;
    }
    return arraySum(array) / array.length;
}

export function standardDeviation(samples) {
    if (!Array.isArray(samples) || samples.length === 0) {
        return 0;
    }
    let variance = 0;
    const average = arrayAverage(samples);
    for (let sample of samples) {
        variance += ((sample - average) ** 2);
    }
    return Math.sqrt(variance / samples.length);
}

export function filterSamples(samples, {
    rejectSampleThreshold = 1.5,
    minSampleValue = 0.0,
    maxSampleValue = Number.MAX_VALUE,
    replaceInvalidValue = undefined,
    ...options
}) {
    if (rejectSampleThreshold <= 0.0) {
        return samples;
    }

    const stdDeviation = standardDeviation(samples);
    const average = arrayAverage(samples);

    let sampleMin = Math.max(average - (stdDeviation * rejectSampleThreshold), minSampleValue);
    let sampleMax = Math.min(average + (stdDeviation * rejectSampleThreshold), maxSampleValue);

    const validSamples = [];
    for (let sample of samples) {
        if (sample >= sampleMin && sample <= sampleMax) {
            validSamples.push(sample);
        } else if (replaceInvalidValue !== undefined) {
            validSamples.push(typeof replaceInvalidValue === 'function'
                ? replaceInvalidValue(sample, samples)
                : replaceInvalidValue
            );
        }
    }
    return validSamples;
}

export function smoothData(data, factor = 0) {
    if (factor === 0) {
        return data;
    }

    const from = -Math.floor(factor / 2);
    const to = Math.ceil(factor / 2);

    let value;
    for (let i = 0; i < data.length; i++) {
        value = 0;
        for (let j = from; j <= to; j++) {
            value += data[Math.min(data.length - 1, Math.max(0, i + j))];
        }
        data[i] = value / factor;
    }
    return data;
}
